var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Rect, Circle, Path, Defs, RadialGradient, Stop, ClipPath } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgChainZora = function SvgChainZora(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#chain-zora_svg__a)"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#chain-zora_svg__b)"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 16,
    cy: 12,
    r: 12,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M19.6 9.59c-.256-.147-.585-.147-.878 0l-2.047 1.214-1.389.773-2.01 1.214c-.256.148-.585.148-.877 0l-1.572-.956a.898.898 0 0 1-.439-.773v-1.84c0-.294.146-.588.439-.772l1.572-.92c.255-.148.584-.148.877 0l1.572.956a.898.898 0 0 1 .438.773v1.214l1.39-.81v-1.25a.909.909 0 0 0-.44-.773l-2.924-1.73c-.255-.147-.585-.147-.877 0L9.438 7.678a.81.81 0 0 0-.439.736v3.458c0 .295.146.59.439.773l2.96 1.73c.256.147.585.147.878 0l2.01-1.178 1.39-.81 2.01-1.177c.256-.147.585-.147.877 0l1.572.92a.898.898 0 0 1 .438.773v1.84a.909.909 0 0 1-.438.772l-1.536.92c-.255.147-.584.147-.877 0l-1.572-.92a.898.898 0 0 1-.438-.772v-1.178l-1.39.81v1.214c0 .294.147.589.44.772l2.96 1.73c.256.147.585.147.877 0l2.961-1.73a.898.898 0 0 0 .439-.772v-3.496a.909.909 0 0 0-.439-.772L19.6 9.59Z",
    fill: "#8247E5"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M4 12c0 6.618 5.382 12 12 12s12-5.382 12-12c-.006-6.618-5.388-12-12-12C9.382 0 4 5.382 4 12Z",
    fill: "url(#chain-zora_svg__c)"
  })))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "chain-zora_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.59 5.846) scale(18.0698)"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.156,
    stopColor: "#DCC8D0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.302,
    stopColor: "#78C8CF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.427,
    stopColor: "#4D959E"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.557,
    stopColor: "#305EB9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.797,
    stopColor: "#311F12"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.906,
    stopColor: "#684232"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2D1C13"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "chain-zora_svg__b"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
export default SvgChainZora;